export const BREAKPOINT_VALUES = {
  base: '0px',
  mobile: '320px',
  mobileLG: '412px',
  tablet: '600px',
  tabletLG: '768px',
  desktop: '1024px',
  desktopMD: '1440px',
  desktopLG: '1920px',
  desktopXL: '2560px',
  desktopXXL: '3840px',
};

export const COMPONENT_CATEGORIES = [
  'Disclosure',
  'Display',
  'Feedback',
  'Form',
  'Layout',
  'Media',
  'Navigation',
  'Overlay',
  'Typography',
];
